import Api from "../../api.service";
import Swal from "sweetalert2";
import store from "../";

const state = {
    usersInfoList: [],
    userInfoForm: {
        firstName: null,
        id: null,
        lastName: null,
        birthDate: null,
        areaId: null,
        areaName: null,
        cityName: null,
        phoneNumber: null,
        code:null
    }
};
const getters = {
    usersInfoList(state) {
        return state.usersInfoList;
    },
    userInfoForm(state) {
        return state.userInfoForm;
    }
};
const mutations = {
    FETCH_USER_INFO(state, payload) {
        console.log(payload);
        state.usersInfoList = payload;
        state.usersInfoList.map(user => {
            user.birthDate = new Date(user.birthDate)
                .toISOString()
                .substr(0, 10);
        });
        store.dispatch("setLoading", false);
    },
    GET_DETAILS_USER(state, payload) {
        if (!state.usersInfoList.length) {
            const Interval = setInterval(() => {
                if (state.usersInfoList.length) {
                    clearInterval(Interval);
                    Object.assign(
                        state.userInfoForm,
                        state.usersInfoList[payload]
                    );
                }
            }, 500);
        }
        Object.assign(state.userInfoForm, state.usersInfoList[payload]);
    },
    DELETE_USER_INFO(state, payload) {
        state.usersInfoList.splice(payload.index, 1);
        Swal.fire({
            title: "تم الحذف !",
            text: `تم حذف المستخدم ${payload.item.firstName +
                " " +
                payload.item.lastName} بنجاح .`,
            icon: "success",
            showConfirmButton: false,
            timer: 1500
        });
    },
    Set_User_Code(state, {  code }) {
         state.userInfoForm.code = code;
     }
};
const actions = {
    async fetchUserInfo(context) {
        store.dispatch("setLoading", true);
        const { data } = await Api.query("/api/UserInfo/GetUsersInfo").then(
            data => data
        );
        context.commit("FETCH_USER_INFO", data);
    },
    getDetailsUser(context, index) {
        context.commit("GET_DETAILS_USER", index);
    },
    async ConfirmDelete(context, item) {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: "btn btn-success px-4",
                cancelButton: "btn btn-danger px-4"
            },
            buttonsStyling: true
        });
        swalWithBootstrapButtons
            .fire({
                title: "هل أنت متأكد؟",
                text: "هل فعلاً تريد حذف المستخدم ؟",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "نعم !",
                cancelButtonText: "إلغاء",
                reverseButtons: false
            })
            .then(result => {
                if (result.value) {
                    const { data } = Api.delete(
                        `/api/UserInfo/RemoveUserInfo?id=${item.item.id}`
                    ).then(data => data);
                    context.commit("DELETE_USER_INFO", item);
                }
            });
    },
    generateUserCode({ commit, state }, index) {
        Api.post(
            `/api/UserInfo/GenerateCode?id=${state.usersInfoList[index].id}`
        ).then(res => {
            commit("Set_User_Code", { code: res.data, index });
        });
    }
};

const userInfo = { state, getters, mutations, actions };
export default userInfo;
